import { render, staticRenderFns } from "./competitionNotice.vue?vue&type=template&id=60b997a8&scoped=true"
import script from "./competitionNotice.vue?vue&type=script&lang=js"
export * from "./competitionNotice.vue?vue&type=script&lang=js"
import style0 from "./competitionNotice.vue?vue&type=style&index=0&id=60b997a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b997a8",
  null
  
)

export default component.exports